import { useNotificationToasts } from './useNotificationToasts';

/**
 * Mounts realtime notification → toast wiring inside KnockFeedProvider.
 */
export function NotificationToastsBridge() {
  useNotificationToasts();
  return null;
}
